var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_003-linkedin-logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "post-linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    className: "st0",
    d: "M50.4,0H5.6C2.5,0,0,2.5,0,5.6v44.8C0,53.5,2.5,56,5.6,56h44.8c3.1,0,5.6-2.5,5.6-5.6V5.6 C56,2.5,53.5,0,50.4,0z M16.8,47.6H8.4V22.4h8.4V47.6z M12.6,17.7c-2.8,0-5-2.3-5-5s2.3-5,5-5s5,2.3,5,5l0,0 C17.6,15.4,15.4,17.7,12.6,17.7C12.6,17.7,12.6,17.7,12.6,17.7z M47.6,47.6h-8.4V32.8c0-2.3-1.9-4.2-4.2-4.2s-4.2,1.9-4.2,4.2 v14.8h-8.4V22.4h8.4v3.4c1.6-2.3,4.2-3.8,7-3.9c5.4,0.1,9.7,4.4,9.8,9.8L47.6,47.6C47.6,47.6,47.6,47.6,47.6,47.6z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedin);
export default __webpack_public_path__ + "static/media/icon-linkedin.994dc757d72d75c5c828acb1e955247c.svg";
export { ForwardRef as ReactComponent };